import { useEffect, useRef } from 'react'
import { type Id, type ToastOptions } from 'react-toastify'
import { toast } from 'react-toastify'
import { useEventSource } from 'remix-utils'
// import { logger } from '#app/utils/logger.ts'
import { parseToast } from './notifications.ts'

export type ToastId = Id
export default toast

export const notify = (msg: string, options?: ToastOptions) =>
	toast(msg, options)

export const loadingNotify = (msg: string, options?: ToastOptions) =>
	toast.loading(msg, options)

export const updateNotify = (id: ToastId, options?: ToastOptions) =>
	toast.update(id, options)

export const dismissToast = (id: ToastId) => toast.dismiss(id)

export const dismissAllToasts = () => toast.dismiss()

export const logOutToast = (
	msg = 'Your session has expired. Please log in again.',
	options?: ToastOptions,
	id?: ToastId,
) =>
	notify(
		msg,
		{
			type: 'info',
			...options,
		},
		// id,
	)

export function useUserToast(toastId: string | null, isHydrated = false) {
	const toastData = useEventSource(`/events/toasts/${toastId}`)
	const toastTime = useRef<number>()

	useEffect(() => {
		// if (isHydrated) {
		if (!toastData) {
			return
		}

		const toast = parseToast(toastData)
		if (toast.createdAt !== toastTime.current) {
			toastTime.current = toast.createdAt
			notify(toast.message, {
				...toast.options,
				toastId: `${toastId}-${toast.createdAt}`,
			})
		}
		// }

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [toastData, isHydrated])
}
